import React from 'react'
import { t } from 'ttag'

import { SendTestsMessageModal } from 'components/modals/common/SendTestsMessageModal/SendTestsMessageModal'
import { JOB_TEMPLATE_MODE } from '../common/SendTestsMessageModal/common/SendTestsMessageForm/model'

export const SendTestsInvitationsModal = ({
  candidates,
  deadline,
  name,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
  mode = JOB_TEMPLATE_MODE,
}) => (
  <SendTestsMessageModal
    title={t`Send invitation message`}
    subtitle={t`Invitation messages`}
    type="invitation"
    mode={mode}
    {...{ candidates, name, deadline, onCancel, onClose, onConfirm, isOpen }}
  />
)
